<template>
  <div class="row">
    <div class="col-xs-12 text-right">
      <router-link :to="{name: 'surveys.view', params: {id: ticket.eventId, customerId: ticket.customerId}}">
        <button
          v-if="areThereSurvey && $can('surveys.view')"
          class="btn btn-info btn-fill btn-icon"
          title="Visualizar pesquisas">
          <i class="ti-eye"></i>
        </button>
      </router-link>
      <button
        v-if="areThereSurvey && $can('surveys.cancel')"
        @click="eraseSurvey()"
        class="btn btn-danger btn-fill btn-icon"
        title="Cancelar Pesquisa">
        <i class="ti-trash"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import swal from 'sweetalert2'
  import {mapActions} from 'vuex'

  export default {
    name: 'survey-customers-actions',

    props: {
      ticket: {required: true},
      survey: {required: true}
    },

    computed: {
      areThereSurvey () {
        return this.survey && this.survey.status === 'FINISHED'
      }
    },

    methods: {
      ...mapActions('surveys', {cleanSurvey: 'cleanSurvey'}),

      eraseSurvey () {
        swal({
          title: 'Você tem certeza?',
          text: `Não será possível reverter essa ação!`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Sim, pode cancelar!',
          buttonsStyling: false
        })
          .then((result) => {
            if (result) {
              this.cleanSurvey(this.survey)
                .then((ress) => {
                  if (ress) {
                    this.swalConfirm()
                  } else {
                    this.swalError()
                  }
                })
            }
          })
      },

      swalConfirm () {
        return swal({
          title: 'Cancelado!',
          text: `A pesquisa foi cancelada com sucesso. Você agora pode associar novamente.`,
          type: 'success',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Ok!',
          buttonsStyling: false
        })
      },

      swalError () {
        return swal({
          title: 'Falhou?',
          text: `Ocorreu um problema no cancelar a pesquisa.`,
          type: 'error',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Ok!',
          buttonsStyling: false
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/Surveys/SurveyCustomerActions.vue